const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class IndependenceDeclaration extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.IndependenceDeclaration,
            "The weakest civilization loses 1 colony (the player choses which one).",
            {}
        )
    }
}

module.exports = IndependenceDeclaration;